import React from 'react'
export const VectorImg = () => {
  return (
<svg width="12" height="12" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="Vector" d="M14.9194 15.0823H1.86493V2.0278H8.39218V0.162872H1.86493C0.829893 0.162872 0 1.00209 0 2.0278V15.0823C0 16.108 0.829893 16.9472 1.86493 16.9472H14.9194C15.9451 16.9472 16.7844 16.108 16.7844 15.0823V8.55505H14.9194V15.0823ZM10.2571 0.162872V2.0278H13.6047L4.43853 11.1939L5.75331 12.5087L14.9194 3.34258V6.69012H16.7844V0.162872H10.2571Z" fill="#585858"/>
</svg>
  )
}
